export default __webpack_public_path__ + "static/media/just_text.b2c60fe7.svg";